import { render } from "./Preloader.vue?vue&type=template&id=69807cba&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=69807cba&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69807cba"]])

export default __exports__